import React from "react";
import { Container, Typography, Divider } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function MarketGuide() {
    const { t } = useTranslation();
    return (
        <Container maxWidth="md">
            <Typography variant="h3" gutterBottom>
                {t('Footer.MarketGuide')}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                {t('Guides.MarketGoal')}
            </Typography>

            <Typography paragraph>
                {t('Guides.MarketDetailsLater')}
            </Typography>

            <Typography paragraph>
                {t('Guides.ContentLater')}
            </Typography>
        </Container>
    );
}
